import * as React from "react";
import PopDetail from "../../popdetail";
import GeneralSelect from "../../general_select";
import {AuthorizationService} from "../../../service/v1/authorization";
import {ProjectsService} from "../../../service/v1/projects";
import ReadService from "../../../service/read";
import Wait from "../../wait";
import CollectService from "../../../service/v1/collect";
import uncheck from "../../../resources/img/checkbox/checkbox_unchecked.png";
import check from "../../../resources/img/checkbox/checkbox_checked.png";

export default class CCROAddUserPane extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            localities: [],
            roles: [],
            nida: '',
            professions: [
                {id: 1, name: 'Land Officer'},
                {id: 2, name: 'Surveyor'},
                {id: 3, name: 'ICT Officer'},
                {id: 4, name: 'GIS Expert'},
                {id: 5, name: 'Others'}
            ],
            team_positions: [
                {value: 'M/Kiti', name: 'Chairman'},
                {value: 'Katibu', name: 'Secretary'},
                {value: 'Mjumbe', name: 'Team Member'}
            ],
            user_existence: {
                endpoint: 'setup/user-existence',
                value: 'id',
                placeholder: 'Select User Existence',
                label: 'name'
            },
            projectUser: {
                endpoint: 'auth/normal-users',
                value: 'id',
                placeholder: 'Select User',
                label: 'username'
            },
            is_new: 'none',
            is_existing: 'none',
            is_common: 'none',
            questionnaires:[],
            checkout_items: [],
            is_land_use: 'none'
        }

        this.loadData = this.loadData.bind(this)
        this.submit = this.submit.bind(this)
        this.handleChanges = this.handleChanges.bind(this)
        this.generalSelect = this.generalSelect.bind(this)
    }

    componentDidMount() {
        this.loadData()
    }

    handleChanges = (e) => {
        this.setState({[e.target.name]: e.target.value})
        /* if (e.target.name === 'user_existence') {
             if (e.target.value === 'existing') {
                 this.setState({
                     is_new: 'table-row'
                 })
             } else {
                 this.setState({
                     is_new: 'none'
                 })
             }
         }*/
    }

    generalSelect(data, name) {
        //console.log(data)
        this.setState({
            [name]: data
        })
        console.log(this.state[name])
        let ids = []
        switch (name) {
            case 'user_existence':
                if (data.value === 'new') {
                    this.setState({
                        is_new: 'table-row',
                        is_common: 'table-row',
                        is_existing: 'none'
                    })
                } else {
                    this.setState({
                        is_new: 'none',
                        is_common: 'table-row',
                        is_existing: 'table-row',
                    })
                }
                break
        }
    }

    toggleCheck(item) {
        let doc = document.getElementById('chk_' + item.name);
        try {
            if (doc.src === uncheck) {
                console.log('CHK')
                doc.src = check;
                console.log('Size : ' + this.state.checkout_items.length)
                this.setState(prevState => {
                    let newItems = [...prevState.checkout_items, item];
                    //newProjects.push(userId);
                    return {
                        checkout_items: newItems, checkout_disabled_btn: 'none',
                        checkout_enabled_btn: 'table-row',
                    };
                });
                console.log('Size 2 : ' + this.state.checkout_items.length)
                return;
            }
            doc.src = uncheck;
            console.log('Size : ' + this.state.checkout_items.length)
            this.setState(prevState => {
                let newItems = prevState.checkout_items.filter((item_in) => item_in !== item);
                //newProjects.push(userId);
                if (newItems.length === 0) {
                    return {
                        checkout_items: newItems, checkout_disabled_btn: 'table-row',
                        checkout_enabled_btn: 'none',
                    };
                } else {
                    return {
                        checkout_items: newItems, checkout_disabled_btn: 'none',
                        checkout_enabled_btn: 'table-row',
                    };
                }
            });
        } catch (e) {
            console.log(e)
        }
    }

    render() {
        const fontFamily = 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif';
        
        const container = {
            width: '100%',
            minHeight: '80vh',
            maxHeight: '80vh',
            background: '#f6f8fa',
            fontFamily,
            padding: '16px',
            overflowY: 'auto',
            overflowX: 'hidden'
        };
        
        const header = {
            padding: '8px 0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            fontSize: 18,
            fontWeight: 700,
            color: '#395d9a',
            fontFamily,
            borderBottom: '1px solid #e0e7ef',
            marginBottom: '12px'
        };
        
        const formCard = {
            background: '#fff',
            borderRadius: 14,
            boxShadow: '0 4px 12px rgba(57,93,154,0.12), 0 2px 4px rgba(57,93,154,0.08)',
            padding: '24px',
            fontFamily,
            marginBottom: '24px',
            border: '1px solid rgba(57,93,154,0.05)'
        };
        
        const sectionTitle = {
            fontSize: 16,
            fontWeight: 600,
            color: '#395d9a',
            marginBottom: '20px',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            paddingBottom: '12px',
            borderBottom: '2px solid #f0f0f0'
        };
        
        const formGrid = {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '20px',
            marginBottom: '20px'
        };
        
        const formGroup = {
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
        };
        
        const label = {
            fontSize: 14,
            fontWeight: 500,
            color: '#666',
            display: 'flex',
            alignItems: 'center',
            gap: 6
        };
        
        const input = {
            padding: '12px 16px',
            border: '1px solid #e0e7ef',
            borderRadius: 8,
            fontSize: 14,
            fontFamily,
            transition: 'border-color 0.2s, box-shadow 0.2s',
            width: '100%',
            boxSizing: 'border-box'
        };
        
        const select = {
            padding: '12px 16px',
            border: '1px solid #e0e7ef',
            borderRadius: 8,
            fontSize: 14,
            fontFamily,
            transition: 'border-color 0.2s, box-shadow 0.2s',
            width: '100%',
            boxSizing: 'border-box',
            background: '#fff'
        };
        
        const radioGroup = {
            display: 'flex',
            gap: '24px',
            alignItems: 'center'
        };
        
        const radioOption = {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: 14,
            color: '#333'
        };
        
        const buttonGroup = {
            display: 'flex',
            gap: '12px',
            justifyContent: 'center',
            marginTop: '24px'
        };
        
        const submitBtn = {
            background: 'linear-gradient(90deg, #2bbbad 0%, #395d9a 100%)',
            color: 'white',
            border: 'none',
            borderRadius: 0,
            padding: '8px 24px',
            fontWeight: 600,
            fontSize: 14,
            cursor: 'pointer',
            fontFamily,
            display: 'flex',
            alignItems: 'center',
            gap: 8
        };
        
        const closeBtn = {
            background: '#e74c3c',
            color: 'white',
            border: 'none',
            borderRadius: 0,
            padding: '8px 24px',
            fontWeight: 600,
            fontSize: 14,
            cursor: 'pointer',
            fontFamily,
            display: 'flex',
            alignItems: 'center',
            gap: 8
        };
        
        const questionnaireCard = {
            background: '#fff',
            borderRadius: 14,
            boxShadow: '0 4px 12px rgba(57,93,154,0.12), 0 2px 4px rgba(57,93,154,0.08)',
            padding: '24px',
            fontFamily,
            border: '1px solid rgba(57,93,154,0.05)'
        };
        
        const questionnaireTable = {
            width: '100%',
            borderCollapse: 'collapse',
            marginTop: '16px'
        };
        
        const tableHeader = {
            background: '#f8f9fa',
            padding: '12px 16px',
            textAlign: 'left',
            fontSize: 14,
            fontWeight: 600,
            color: '#395d9a',
            borderBottom: '2px solid #e0e7ef'
        };
        
        const tableCell = {
            padding: '12px 16px',
            fontSize: 14,
            color: '#333',
            borderBottom: '1px solid #f0f0f0'
        };
        
        const checkboxCell = {
            textAlign: 'center',
            width: '80px'
        };
        
        return (
            <div style={container}>
                <div style={header}>
                    <span>
                        <span className={'fa fa-user-plus'} style={{marginRight: 12}}/>
                        Add Project User
                    </span>
                </div>
                
                <div style={formCard}>
                    <div style={sectionTitle}>
                        <span className={'fa fa-user'} style={{color: '#395d9a'}}/>
                        User Information
                    </div>
                    
                    <div style={formGrid}>
                        <div style={formGroup}>
                            <label style={label}>
                                <span className={'fa fa-users'} style={{color: '#666', fontSize: 12}}/>
                                User Existence
                            </label>
                            <GeneralSelect 
                                onChanges={(e) => this.generalSelect(e, 'user_existence')}
                                parameters={this.state.user_existence} 
                                isMulti={false}
                            />
                        </div>
                        
                        {this.state.is_existing === 'table-row' && (
                            <div style={formGroup}>
                                <label style={label}>
                                    <span className={'fa fa-user'} style={{color: '#666', fontSize: 12}}/>
                                    Select User
                                </label>
                                <GeneralSelect 
                                    onChanges={(e) => this.generalSelect(e, 'project_user')}
                                    parameters={this.state.projectUser} 
                                    isMulti={false}
                                />
                            </div>
                        )}
                    </div>
                    
                    {this.state.is_new === 'table-row' && (
                        <>
                            <div style={sectionTitle}>
                                <span className={'fa fa-user-plus'} style={{color: '#395d9a'}}/>
                                New User Details
                            </div>
                            
                            <div style={formGrid}>
                                <div style={formGroup}>
                                    <label style={label}>
                                        <span className={'fa fa-user'} style={{color: '#666', fontSize: 12}}/>
                                        First Name
                                    </label>
                                    <input 
                                        type={'text'} 
                                        style={input} 
                                        name={'first_name'}
                                        onChange={this.handleChanges}
                                        placeholder="Enter first name"
                                    />
                                </div>
                                
                                <div style={formGroup}>
                                    <label style={label}>
                                        <span className={'fa fa-user'} style={{color: '#666', fontSize: 12}}/>
                                        Middle Name
                                    </label>
                                    <input 
                                        type={'text'} 
                                        style={input} 
                                        name={'middle_name'}
                                        onChange={this.handleChanges}
                                        placeholder="Enter middle name"
                                    />
                                </div>
                                
                                <div style={formGroup}>
                                    <label style={label}>
                                        <span className={'fa fa-user'} style={{color: '#666', fontSize: 12}}/>
                                        Last Name
                                    </label>
                                    <input 
                                        type={'text'} 
                                        style={input} 
                                        name={'last_name'}
                                        onChange={this.handleChanges}
                                        placeholder="Enter last name"
                                    />
                                </div>
                            </div>
                            
                            <div style={formGrid}>
                                <div style={formGroup}>
                                    <label style={label}>
                                        <span className={'fa fa-venus-mars'} style={{color: '#666', fontSize: 12}}/>
                                        Gender
                                    </label>
                                    <div style={radioGroup}>
                                        <label style={radioOption}>
                                            <input type={'radio'} name={'gender'} value="male" onChange={this.handleChanges}/>
                                            Male
                                        </label>
                                        <label style={radioOption}>
                                            <input type={'radio'} name={'gender'} value="female" onChange={this.handleChanges}/>
                                            Female
                                        </label>
                                    </div>
                                </div>
                                
                                <div style={formGroup}>
                                    <label style={label}>
                                        <span className={'fa fa-envelope'} style={{color: '#666', fontSize: 12}}/>
                                        Email
                                    </label>
                                    <input 
                                        type={'email'} 
                                        style={input} 
                                        name={'email'}
                                        onChange={this.handleChanges}
                                        placeholder="Enter email address"
                                    />
                                </div>
                                
                                <div style={formGroup}>
                                    <label style={label}>
                                        <span className={'fa fa-phone'} style={{color: '#666', fontSize: 12}}/>
                                        Phone Number
                                    </label>
                                    <input 
                                        type={'tel'} 
                                        style={input} 
                                        name={'phone'}
                                        onChange={this.handleChanges}
                                        placeholder="Enter phone number"
                                    />
                                </div>
                            </div>
                        </>
                    )}
                    
                    {this.state.is_common === 'table-row' && (
                        <>
                            <div style={sectionTitle}>
                                <span className={'fa fa-cog'} style={{color: '#395d9a'}}/>
                                Role & Assignment
                            </div>
                            
                            <div style={formGrid}>
                                <div style={formGroup}>
                                    <label style={label}>
                                        <span className={'fa fa-user-tag'} style={{color: '#666', fontSize: 12}}/>
                                        Role
                                    </label>
                                    <select name={'role'} onChange={this.handleChanges} style={select}>
                                        <option value={undefined}>- Select Role -</option>
                                        {this.state.roles.map((d, i) => (
                                            <option key={i} value={d.id}>{d.name}</option>
                                        ))}
                                    </select>
                                </div>
                                
                                <div style={formGroup}>
                                    <label style={label}>
                                        <span className={'fa fa-briefcase'} style={{color: '#666', fontSize: 12}}/>
                                        Professional
                                    </label>
                                    <select name={'profession'} onChange={this.handleChanges} style={select}>
                                        <option value={undefined}>- Select Profession -</option>
                                        {this.state.professions.map((d, i) => (
                                            <option key={i} value={d.name}>{d.name}</option>
                                        ))}
                                    </select>
                                </div>
                                
                                <div style={formGroup}>
                                    <label style={label}>
                                        <span className={'fa fa-users'} style={{color: '#666', fontSize: 12}}/>
                                        Team Position
                                    </label>
                                    <select name={'team_position'} onChange={this.handleChanges} style={select}>
                                        <option value={undefined}>- Select Position -</option>
                                        {this.state.team_positions.map((d, i) => (
                                            <option key={i} value={d.value}>{d.name}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            
                            <div style={formGroup}>
                                <label style={label}>
                                    <span className={'fa fa-map-marker'} style={{color: '#666', fontSize: 12}}/>
                                    Project Locality Boundary
                                </label>
                                <select style={select} name={'locality'} onChange={this.handleChanges}>
                                    <option value={undefined}>- Choose Locality -</option>
                                    {this.state.localities.map((d, i) => (
                                        <option value={d.id} key={i}>{d.name} Boundary</option>
                                    ))}
                                </select>
                            </div>
                        </>
                    )}
                    
                    <div style={buttonGroup}>
                        <button style={submitBtn} onClick={this.submit}>
                            <span className={'fa fa-save'}/>Submit
                        </button>
                        <button style={closeBtn} onClick={() => PopDetail.dismiss()}>
                            <span className={'fa fa-times'}/>Close
                        </button>
                    </div>
                </div>
                
                {this.state.is_land_use === 'block' && (
                    <div style={questionnaireCard}>
                        <div style={sectionTitle}>
                            <span className={'fa fa-list'} style={{color: '#395d9a'}}/>
                            Dodoso Categories
                        </div>
                        
                        <div style={{
                            display: this.state.search_success,
                            overflowX: 'hidden',
                            overflowY: 'auto',
                            maxHeight: '400px'
                        }}>
                            <table style={questionnaireTable}>
                                <thead>
                                    <tr>
                                        <th style={tableHeader}>No.</th>
                                        <th style={tableHeader}>Dodoso Category</th>
                                        <th style={{...tableHeader, textAlign: 'center'}}>Selected</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.questionnaires.map((d, i) => (
                                        <tr key={i}>
                                            <td style={tableCell}>{i + 1}</td>
                                            <td style={tableCell}>
                                                <span style={{color: 'darkcyan', fontWeight: 500}}>{d.name}</span>
                                            </td>
                                            <td style={{...tableCell, ...checkboxCell}}>
                                                <img 
                                                    id={'chk_' + d.name} 
                                                    alt={'chk_' + d.name} 
                                                    src={uncheck}
                                                    onClick={() => this.toggleCheck(d)}
                                                    style={{cursor: 'pointer', width: '20px', height: '20px'}}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        )
    }

    loadData() {
        try {
            AuthorizationService.listRoles().then(r => {
                try {
                    this.setState({
                        roles: r.data.results
                    })
                } catch (e) {
                    console.log(e)
                }
            })
        } catch (e) {
            console.log(e)
        }
        try {
            ReadService.fetchLocalitiesByProject(this.props.project.id).then(r => {
                try {
                    this.setState({
                        localities: r.data.results
                    })
                } catch (e) {
                    console.log(e)
                }
            })
        } catch (e) {
            console.log(e)
        }

        if (this.props.project.project_type_info.name.toString().toLowerCase().includes("monitoring")
            || this.props.project.project_type_info.name.toString().toLowerCase().includes("land use"))
            try {
                console.log("POINT....")
                CollectService.fetchQuestions(this.props.project.id, 1).then(r => {
                    try {
                        let result = r.data.results
                        let loc = r.data.localities

                        if (loc.regions.length === 1) {
                            this.setState({
                                parent_id: loc.regions[0].id
                            })
                        }
                        this.setState({
                            questionnaires: result,
                            regions: loc.regions,
                            districts: loc.districts,
                            wards: loc.wards,
                            villages: loc.villages,
                            hamlets: loc.hamlets,
                            is_land_use: 'block',
                        })
                        /* if (result.length>0){
                             this.loadQuestionnairesForms(result[0].id)
                         }*/
                    } catch (e) {
                        Wait.dismiss()
                        console.log(e)
                    }
                })
            } catch (e) {
                console.log(e)
            }


        /*LUSPlanReadService.listProjectVillage(LandUseProject.projectId).then(r => {
           try{
               this.setState({
                   villages:r.data.results
               })
           }catch (e) {
               console.log(e)
           }
       })



       LUSPlanReadService.readDictionary('professional').then(r =>{
           try {
               this.setState({
                   professions:r.data.results
               })
           }catch (e) {
               console.log(e)
           }
       })*/
    }

    submit() {
        //let nida = this.state.nida
        console.log("User Existence : " + this.state.user_existence.value)

        let categories = []
        this.state.checkout_items.map((d,i)=>{
            categories.push(d.id)
        })
        console.log(categories)
        try {
            if (this.state.user_existence.value === 'existing') {
                console.log("User : " + this.state.project_user.value)
                let role_id = this.state.role
                let profession = this.state.profession
                let team_position = this.state.team_position
                let locality_id = this.state.locality
                Wait.show('Saving...')
                ProjectsService.addProjectUser({
                    user_id: this.state.project_user.value,
                    project_id: this.props.project.id,
                    locality_id: locality_id,
                    team_position: team_position,
                    group_id: role_id,
                    professional: profession,
                    task_id: this.props.taskId,
                    screen_code: this.props.screen_code,
                    categories: categories.toString()
                }).then(r => {
                    Wait.dismiss()
                    try {
                        alert(r.data.message)
                        PopDetail.dismiss()
                        this.props.loadData()
                    } catch (e) {
                        console.log(e)
                    }
                })
            } else {
                let email = this.state.email
                let phone = this.state.phone
                let first_name = this.state.first_name
                let last_name = this.state.last_name
                let role_id = this.state.role
                let profession = this.state.profession
                let middle_name = this.state.middle_name
                let gender = this.state.gender
                let team_position = this.state.team_position
                let locality_id = this.state.locality

                Wait.show('Saving...')
                ProjectsService.createProjectUser({
                    project_id: this.props.project.id,
                    email: email,
                    phone: phone,
                    gender: gender,
                    middle_name: middle_name,
                    first_name: first_name,
                    last_name: last_name,
                    locality_id: locality_id,
                    team_position: team_position,
                    group_id: role_id,
                    station_id: '',
                    professional: profession,
                    task_id: this.props.taskId,
                    screen_code: this.props.screen_code,
                    categories: categories.toString()
                }).then(r => {
                    Wait.dismiss()
                    try {
                        alert(r.data.message)
                        PopDetail.dismiss()
                        this.props.loadData()
                    } catch (e) {
                        console.log(e)
                    }
                })
            }
        } catch (e) {
            console.log(e)
        }
    }
}
